// extracted by mini-css-extract-plugin
module.exports = {"section":"InviteCanceled_section__1tPMZ"};